module.exports = __webpack_public_path__ + "img/clock.c342986d.svg";